import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { config } from '../../config';

export default function TransactionsEtudiant() {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  // Utilisation de la configuration centralisée
  const API_BASE = config.apiBase;
  const getToken = () => localStorage.getItem('token');

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const token = getToken();
        const response = await fetch(`${API_BASE}/etudiant/transactions/get_mes_transactions.php`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        if (data.success) setTransactions(data.transactions);
      } catch (error) {
        toast.error('Erreur de chargement');
      } finally {
        setLoading(false);
      }
    };
    fetchTransactions();
  }, []);

  const filteredTransactions = transactions.filter(t => {
    if (filter === 'all') return true;
    if (filter === 'achat') return t.type === 'achat_cours';
    if (filter === 'debit') return t.type === 'debit_repas' || t.type === 'debit_bus';
    if (filter === 'recharge') return t.type === 'recharge';
    return true;
  });

  const getIcon = (type) => {
    switch(type) {
      case 'achat_cours': return '📚';
      case 'debit_repas': return '🍽️';
      case 'debit_bus': return '🚌';
      case 'recharge': return '💰';
      default: return '💳';
    }
  };

  const getColor = (type) => {
    switch(type) {
      case 'achat_cours': return 'text-purple-600';
      case 'debit_repas': return 'text-orange-600';
      case 'debit_bus': return 'text-blue-600';
      case 'recharge': return 'text-green-600';
      default: return 'text-gray-600';
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Chargement de vos transactions...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800">💰 Mes transactions</h1>
        <p className="text-gray-500">Historique de toutes vos transactions</p>
      </div>

      <div className="flex gap-2 mb-6 overflow-x-auto">
        <button onClick={() => setFilter('all')} className={`px-4 py-2 rounded-lg transition ${filter === 'all' ? 'bg-green-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}>Toutes</button>
        <button onClick={() => setFilter('achat')} className={`px-4 py-2 rounded-lg transition ${filter === 'achat' ? 'bg-purple-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}>Achats cours</button>
        <button onClick={() => setFilter('debit')} className={`px-4 py-2 rounded-lg transition ${filter === 'debit' ? 'bg-orange-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}>Débits</button>
        <button onClick={() => setFilter('recharge')} className={`px-4 py-2 rounded-lg transition ${filter === 'recharge' ? 'bg-green-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}>Recharges</button>
      </div>

      {filteredTransactions.length === 0 ? (
        <div className="bg-white rounded-xl shadow-md p-12 text-center">
          <div className="text-5xl mb-4">💰</div>
          <p className="text-gray-500">Aucune transaction trouvée</p>
        </div>
      ) : (
        <div className="space-y-3">
          {filteredTransactions.map(transaction => (
            <div key={transaction.id} className="bg-white rounded-lg shadow-md p-4 hover:shadow-lg transition">
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-xl">{getIcon(transaction.type)}</div>
                  <div>
                    <p className="font-semibold text-gray-800">{transaction.libelle}</p>
                    <p className="text-xs text-gray-400">{new Date(transaction.date).toLocaleString()}</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className={`font-bold text-lg ${getColor(transaction.type)}`}>
                    {transaction.montant > 0 ? '+' : ''}{transaction.montant.toLocaleString()} F
                  </p>
                  {transaction.solde_apres && <p className="text-xs text-gray-500">Solde: {transaction.solde_apres.toLocaleString()} F</p>}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}